import { SubscriptionLandingInfo } from "../../types/Paywall";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

export const createPaywall = async (
  paywall: SubscriptionLandingInfo & { id?: string }
): Promise<string | void> => {
  if (!paywall.id) {
    throw new Error("Community ID is required to create a paywall");
  }

  const paywallRef = firestore
    .collection(DB_PATH.COMMUNITY)
    .doc(paywall.id)
    .collection("landingPage")
    .doc("info");

  console.log("Creating paywall for community:", paywall.id);

  // Remove the id from the payload since we're storing it at the document level
  const { id, ...data } = paywall;

  // Remove undefined fields (Firestore doesn't accept undefined values)
  const payload = Object.entries(data).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {} as any);

  try {
    await paywallRef.set(payload, { merge: true });
    return paywall.id;
  } catch (error) {
    console.error("Error creating paywall", error);
  }
};
